import { ComponentConfig } from "@measured/puck";
import { Box } from "@mui/material";

import { PageBreak as PageBreakComponent, PageBreakProps } from "./PageBreak";

export type { PageBreakProps } from "./PageBreak";
export { PAGE_BREAK_MARKER_CLASS } from "./PageBreak";

export const PageBreak: ComponentConfig<PageBreakProps> = {
    label: "Page Break",
    fields: {
        showInEditor: {
            type: "radio",
            label: "Show in editor",
            options: [
                { label: "Visible", value: true },
                { label: "Hidden", value: false },
            ],
        },
    },
    defaultProps: {
        showInEditor: true,
    },
    render: (props) => {
        return (
            <Box>
                <PageBreakComponent {...props} />
            </Box>
        );
    },
};
